import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IsNullOrEmpty } from '../../core/utility';
import { post } from '../../core/client';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { SentimentVeryDissatisfied, TaskAlt } from '@mui/icons-material';
import kocAilemlogo from '../../assets/images/koc-ailem-logo.png';
import ConfirmationModal from '../../components/confirmation-modal';

const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

const WhatsappUnsubscribe = () => {

    let query = useQuery();
    const encriptedText = query.get('subs');

    const [isSend, setIsSend] = useState<boolean>(false);
    const [sendLoading, setSendLoading] = useState<boolean>(false);
    const [isFailed, setIsFailed] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(true);

    useEffect(() => {
        if (!IsNullOrEmpty(encriptedText)) {
            //sendUnsubscribe(encriptedText as string)
            setShowConfirmationModal(true);
        }
    }, [encriptedText])

    const sendUnsubscribe = async (encriptedText: string) => {
        setIsFailed(false);
        setIsSend(false);
        setSendLoading(true);
        const request = {
            subs: encriptedText
        }
        const { data, fail, errorMessage } = await post<any>('api/membership/whatsapp-unsubscribe', request);
        setSendLoading(false);
        if (data) {
            setIsSend(true);
        }
        if (fail) {
            setIsFailed(true);
        }
    }

    const handleSave = async () => {
        setShowConfirmationModal(false);
        sendUnsubscribe(encriptedText as string)    
    }

    return (
        <Container maxWidth="md">
            {
                sendLoading ?
                    <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" paddingY={2}>
                        <p>Talebiniz iletiliyor...</p>
                        <CircularProgress />
                    </Box>
                    : isSend && (
                        <>
                            <Box paddingY={4} textAlign="center" className="success-container">
                                <TaskAlt className='success-icon' color='success' />
                                <p>Whatsapp iletişim listesinden çıkarılma talebiniz alınmıştır.</p>
                                <p>Whatsapp üzerinden tekrar iletişime geçilmesini isterseniz <strong>iletisim@kocailem.com.tr</strong> adresine eposta gönderebilirsiniz.</p>
                            </Box>
                            <Box display="flex" justifyContent="center">
                                <img src={kocAilemlogo} alt='KoçAilem Logo' />
                            </Box>
                        </>
                    )
            }
            {
                isFailed && (
                    <Box paddingY={4} textAlign="center" className="success-container">
                        <SentimentVeryDissatisfied className='success-icon' color='error' />
                        <p>Talep iletilirken bir sorun yaşandı. Lütfen, bir kaç dakika sonra tekrar deneyiniz.</p>
                        <p>Sorun devam ediyorsa <strong>iletisim@kocailem.com.tr</strong> adresi üzerinden iletişime geçebilirsiniz.</p>                        
                    </Box>
                )
            }

{showConfirmationModal && (
                <ConfirmationModal
                    showModal={showConfirmationModal}
                    item={{
                       verificationText:"WhatsApp üzerinden KoçAilem'in en önemli ayrıcalıkları hakkında bilgi almak istemiyorum.",
                       approveButtonText:"Whatsapp mesajlarını iptal et",
                       notApproveButtonTest:"VAZGEÇ",
                       redirectUrl:'https://kocailem.com'
                    }}
                    onVerified={handleSave}
                    onClose={() => setShowConfirmationModal(false)}
                />
            )}

        </Container>
    )
}

export default WhatsappUnsubscribe